/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { contactSchema } from './contact-schema';
import { opportunitySchema } from './opportunity-schema';
import { userSchema } from './user-schema';
import { OpportunityContactRole } from "../enums";

export const contactsOpportunitySchema: z.AnyZodObject = z.object({
  contact: z.lazy(() => contactSchema).nullish(),
  contactId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  createdById: z.string().uuid().nullish(),
  createdByUser: z.lazy(() => userSchema).nullish(),
  id: z.string().uuid(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  role: z.nativeEnum(OpportunityContactRole).nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type ContactsOpportunity = z.infer<typeof contactsOpportunitySchema>;
